import { sharedPage } from '../../assets/shared.styles';

export const styles = {
  container: {
    ...sharedPage.container,
  },
};
